import * as React from 'react';
import styled from 'styled-components';
import Container from '@lendi-ui/container';
import { px, py, mx } from '@lendi-ui/spacing';
import { Cta } from '../../utils/schema';
import { ArticleCta } from './ArticleCta';

const Wrapper = styled.div<{ showImage: boolean }>`
  ${py('lg')}
  ${px({ mobile: 'md', desktop: 'xxs' })}
  ${mx('auto')}
  max-width: ${({ showImage }) => (showImage ? '48rem' : '40rem')};
`;

interface BottomCtaProps {
  ctas: Cta[];
  showImage?: boolean;
}
export const BottomCta = ({ ctas, showImage = false }: BottomCtaProps) => {
  return (
    <Wrapper showImage={showImage}>
      <Container>
        <ArticleCta cta={ctas[0] as Cta} showImage={showImage} />
      </Container>
    </Wrapper>
  );
};
